export enum LicenceRoleType {
    man = 'mandatary',
    manBbc = 'mandatary.bbc',
    cfo = 'cfo',    // administration
    bank = 'banker',
    admin = 'administrator',    // master user
    bzd = 'bizzdev',
    bko = 'backoffice',
    servicing = 'servicing'
}
